import { request } from '@/utils/request'

// 获取 Settings 聚合配置（文档：GET /shopify-app/setting）
export const getSettings = () => {
  return request('/shopify-app/setting', {
    method: 'GET',
  })
}

// 同步 Shopify shipping zones（文档：GET /shopify-app/setting/shiping-zones-sync）
export const syncShippingZones = () => {
  return request('/shopify-app/setting/shiping-zones-sync', {
    method: 'GET',
  })
}

// 禁用国家（文档：GET/PUT /shopify-app/setting/forbidden-countries）
export const getForbiddenCountries = () => {
  return request<string[]>('/shopify-app/setting/forbidden-countries', {
    method: 'GET',
  })
}

export const setForbiddenCountries = (countries: string[]) => {
  return request('/shopify-app/setting/forbidden-countries', {
    method: 'PUT',
    data: { countries },
  })
}

// 报表时区（文档：GET/PUT /shopify-app/setting/time-zone）
export const getReportTimezone = () => {
  return request<{ reportTimezone: string }>('/shopify-app/setting/time-zone', {
    method: 'GET',
  })
}

export const setReportTimezone = (reportTimezone: string) => {
  return request('/shopify-app/setting/time-zone', {
    method: 'PUT',
    data: { reportTimezone },
  })
}

// 语言（文档：GET/PUT /shopify-app/setting/language）
export const getLanguageSetting = () => {
  return request<{ language: string;}>('/shopify-app/setting/language', {
    method: 'GET',
  })
}

export const setLanguageSetting = (data: { language: string;}) => {
  return request('/shopify-app/setting/language', {
    method: 'PUT',
    data,
  })
}

// 订阅 URL（文档：PUT /shopify-app/setting/subscription-url）
export const setSubscriptionUrl = (subscriptionUrl: string) => {
  return request('/shopify-app/setting/subscription-url', {
    method: 'PUT',
    data: { subscriptionUrl },
  })
}

// Logo（文档：PUT/DELETE/POST /shopify-app/setting/logo）
export const setLogoUrl = (url: string) => {
  return request('/shopify-app/setting/logo', {
    method: 'PUT',
    data: { url },
  })
}

export const deleteLogo = () => {
  return request('/shopify-app/setting/logo', {
    method: 'DELETE',
    data: {},
  })
}

// 支付配置（文档：PUT /shopify-app/setting/paypal|cards|wallets）
export const updatePaypalSetting = (shopApi: Record<string, any>) => {
  return request('/shopify-app/setting/paypal', {
    method: 'PUT',
    data: { shopApi },
  })
}

export const updateCardsSetting = (ccApi: Record<string, any>) => {
  return request('/shopify-app/setting/cards', {
    method: 'PUT',
    data: { ccApi },
  })
}

export const updateWalletsSetting = (shopApi: Record<string, any>) => {
  return request('/shopify-app/setting/wallets', {
    method: 'PUT',
    data: { shopApi },
  })
}

// Storefront token（文档：PUT /shopify-app/setting/storefront-access）
export const updateStorefrontAccessToken = (storefrontApiAccessToken: string, storefrontPrivateToken: string) => {
  return request('/shopify-app/setting/storefront-access', {
    method: 'PUT',
    data: { storefrontApiAccessToken, storefrontPrivateToken },
  })
}

// 校验 Storefront token（文档：GET /shopify-app/setting/storefront-auth/validate）
export const validateStorefrontAccessToken = () => {
  return request('/shopify-app/setting/storefront-auth/validate', {
    method: 'GET',
  })
}
